import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64d0670a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-label": "Page navigation example" }
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = { class: "page-item" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon bi-chevron-double-left"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "page-item d-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "page-link border-0 border-light" }, "....")
], -1))
const _hoisted_9 = { class: "page-item" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon bi-chevron-double-right"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickFirstPage && _ctx.onClickFirstPage(...args))),
            disabled: _ctx.isInFirstPage,
            "aria-label": "First"
          }, _hoisted_6, 8, _hoisted_4)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "page-item",
            key: i
          }, [
            (item.name > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["page-link", {
              active: _ctx.isPageActive(item.name),
            }]),
                  onClick: ($event: any) => (_ctx.onClickPage(item.name)),
                  type: "button",
                  disabled: item.isDisabled
                }, _toDisplayString(item.name), 11, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _hoisted_8,
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickLastPage && _ctx.onClickLastPage(...args))),
            disabled: _ctx.isInLastPage,
            "aria-label": "Last"
          }, _hoisted_12, 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}